import { fetchJSON } from "./utils"

const BASE_URL = "/api/v2/ticket_priority"

const fetchAll = async (organizationId) => {
    const params = {
        organization_id: organizationId
    }
    return await fetchJSON(BASE_URL, params, null, "GET", false)
}

const create = async (name, colour, icon, notes, organizationId) => {
    const body = {
        name,
        colour,
        icon,
        notes,
        organization_id: organizationId
    }
    return await fetchJSON(BASE_URL, null, body, "POST")
}

const update = async (id, name = null, colour = null, icon = null, notes = null) => {
    const url = `${BASE_URL}/${id}`
    const body = {
        name,
        colour,
        icon,
        notes
    }
    return await fetchJSON(url, null, body, "PATCH")
}

const del = async (id) => {
    const url = `${BASE_URL}/${id}`
    return await fetchJSON(url, null, null, "DELETE")
}

export default {
    fetchAll,
    create,
    update,
    del
}
